<div class="alarm-setup">
  <div class="alarm-setup__configuration" *ngIf="!isEnabled">
    <div class="alarm-setup__time-section">
      <div class="alarm-setup__time-controls">
        <div class="time-control">
          <button
            mat-icon-button
            class="time-control__button time-control__button--up htv-selectable"
            (click)="incrementHours()">
            <mat-icon>&#xe316;</mat-icon>
          </button>

          <div class="time-control__display">
            <span class="time-control__value">{{ formattedHours }}</span>
            <span class="time-control__label mat-body-medium">{{ 'PAGES.WAKE_UP_ALARM.HOURS' | translate }}</span>
          </div>

          <button
            mat-icon-button
            class="time-control__button time-control__button--down htv-selectable"
            (click)="decrementHours()">
            <mat-icon>&#xe313;</mat-icon>
          </button>
        </div>

        <div class="time-separator">
          <span class="time-separator__colon">:</span>
        </div>

        <div class="time-control">
          <button
            mat-icon-button
            class="time-control__button time-control__button--up htv-selectable"
            (click)="incrementMinutes()">
            <mat-icon>&#xe316;</mat-icon>
          </button>

          <div class="time-control__display">
            <span class="time-control__value">{{ formattedMinutes }}</span>
            <span class="time-control__label mat-body-medium">{{ 'PAGES.WAKE_UP_ALARM.MINUTES' | translate }}</span>
          </div>

          <button
            mat-icon-button
            class="time-control__button time-control__button--down htv-selectable"
            (click)="decrementMinutes()">
            <mat-icon>&#xe313;</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="alarm-setup__wake-mode">
      <div class="alarm-setup__mode-selector">
        <div
          class="mode-tab htv-selectable"
          [class.mode-tab--active]="wakeUpMode === 'sound'"
          (click)="selectSoundMode()">
          <mat-icon>&#xe050;</mat-icon>
          <div class="mode-tab__label">{{ 'PAGES.WAKE_UP_ALARM.SOUND' | translate }}</div>
        </div>

        <div
          class="mode-tab htv-selectable"
          [class.mode-tab--active]="wakeUpMode === 'channel'"
          (click)="selectChannelMode()">
          <mat-icon>&#xe333;</mat-icon>
          <div class="mode-tab__label">{{ 'PAGES.WAKE_UP_ALARM.TV_CHANNEL' | translate }}</div>
        </div>
      </div>

      <div class="channel-selector-wrapper" *ngIf="wakeUpMode === 'channel'">
        <app-channel-selector
          [channels]="channels"
          [selectedChannel]="selectedChannel"
          (channelSelected)="onChannelSelected($event)">
        </app-channel-selector>
      </div>
    </div>

    <div class="alarm-setup__actions">
      <button mat-raised-button class="enable-button htv-selectable" (click)="enableAlarm()">
        <mat-icon>&#xe858;</mat-icon>
        <span>{{ 'PAGES.WAKE_UP_ALARM.ENABLE' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="alarm-setup__active-status" *ngIf="isEnabled">
    <div class="alarm-status alarm-status--active">
      <div class="alarm-status__time mat-headline-large">
        {{ formattedTime }}
      </div>
      <div class="alarm-status__mode mat-body-medium">
        <mat-icon>{{ wakeUpMode === 'sound' ? '&#xe050;' : '&#xe333;' }}</mat-icon>
        <span>{{ wakeUpMode === 'sound' ? ('PAGES.WAKE_UP_ALARM.SOUND' | translate) : selectedChannel?.name }}</span>
      </div>
      <div class="alarm-setup__wake-message">
        <span class="wake-message">{{ getWakeUpMessage() }}</span>
      </div>
    </div>

    <div class="alarm-setup__actions">
      <button mat-raised-button class="disable-button htv-selectable" (click)="disableAlarm()">
        <mat-icon>&#xe857;</mat-icon>
        <span>{{ 'PAGES.WAKE_UP_ALARM.DISABLE' | translate }}</span>
      </button>
    </div>
  </div>
</div>
